import * as React from 'react';

import { IncognitoModeContainer } from 'containers/project-love/features/incognito-mode-container';

const Page: React.FunctionComponent = () => {
  return <IncognitoModeContainer />;
};

export default Page;

export { getServerSideProps } from 'lib/get-server-side-props';
